/**
 * オンボーディングページ コンテナ
 */
import type React from "react";
import { useCallback, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../hooks/authProvider/authProvider";
import {
  type CreateTenantInput,
  useCreateTenant,
} from "../../hooks/useTenantApi";
import { type OnboardingFormValues, OnboardingPage } from "./OnboardingPage";

const OnboardingPageContainer: React.FC = () => {
  const navigate = useNavigate();
  const { refetchMe } = useContext(AuthContext);
  const { createTenant, loading: isCreating } = useCreateTenant();
  const [error, setError] = useState<string | undefined>(undefined);

  const methods = useForm<OnboardingFormValues>({
    defaultValues: {
      name: "",
      description: "",
    },
  });

  const handleSubmit = useCallback(
    async (values: OnboardingFormValues) => {
      setError(undefined);
      try {
        const input: CreateTenantInput = {
          name: values.name,
          ...(values.description && { description: values.description }),
        };
        await createTenant(input);
        // ユーザー情報を再取得してテナント情報を更新
        await refetchMe?.();
        // ホームへリダイレクト
        navigate("/");
      } catch (e) {
        const err = e instanceof Error ? e : new Error(String(e));
        setError(err.message || "テナントの作成に失敗しました");
      }
    },
    [createTenant, refetchMe, navigate],
  );

  return (
    <OnboardingPage
      methods={methods}
      onSubmit={handleSubmit}
      isSubmitting={isCreating}
      error={error}
    />
  );
};

export default OnboardingPageContainer;
